import React from 'react';

export const AuthLayout = ({ children }) => {
	return <>{children}</>;
};
